import React, { useEffect } from 'react';
import { AxiosError, AxiosResponse } from 'axios';

import { axiosInstance } from 'shared/services/http.service';
import { IResponseObj } from 'shared/interface';
import Notification, { notify } from 'shared/components/notification/notification';
import { useUserContext } from 'shared/components/userContext/userContext';

const WithErrorHandler: React.FC = () => {
	const {} = useUserContext();

	useEffect(() => {
		const resInterceptor = axiosInstance.interceptors.response.use(
			(res: AxiosResponse<IResponseObj<any>>) => {
				const data = res.data;
				if (data && data.message) {
					if (data.isError) {
						notify(data.data.error, 'error');
						throw new Error(data.message as string);
					}
				}

				return res;
			},
			(error: AxiosError<IResponseObj<any>>) => {
				const res = error.response;
				// check if error is having data
				if (res && res.data && res.status) {
					const status = res.status;
					const responseData = res.data;

					// is http error code is 401, log out of the application
					if (status === 401 && responseData) {
						notify(responseData.data.error, 'error');
					} else if (status === 500 && responseData) {
						notify(responseData.message, 'error');
					} else if (status === 400 && responseData) {
						notify(responseData?.error as string, 'error');
					} else if (res && responseData) {
						// if error data contains message field, add error notification
						notify(responseData.data.error, 'error');
					} else {
						notify(responseData.data.error, 'error');
					}
					throw error;
				}
			}
		);

		return () => axiosInstance.interceptors.response.eject(resInterceptor);
	}, []);

	return <Notification />;
};

export default WithErrorHandler;
